import StyledContainer from "style/styledContainer"
import styled from "styled-components"


import outBgImg from 'assets/images/out_bg.png'
import SwitchBtnCom from "components/SwitchBtnCom"
import PayNumberCom from "components/PayNumberCom"
import { useAppDispatch, useAppSelector } from "hooks/redux/hooks"
import LoadingWin from "components/LoadingWin"
import Brc20ReclipAddrCom from "components/Brc20/Brc20ReclipAddrCom"
import EmptyWalletCom from "components/Brc20/EmptyWalletCom"
import InscriptionListCom from "components/Brc20/InscriptionListCom"
import AssetsSelectBrc20Com from "components/Brc20/AssetsSelectBrc20Com"
import useBrc20Utils from "hooks/brc20/useBrc20Utils"
import useBrc20DefData from "hooks/brc20/useBrc20DefData"
import ReceiveBrc20Com from "components/Brc20/ReceiveBrc20Com"
import { useEffect } from "react"
import { useUnisatWallet } from "hooks/wallet/useUnisatWalletProvider"
import { useOkxBitcoinWallet } from "hooks/wallet/useOkxBitcoinWalletProvider"
import { setToToken } from "hooks/redux/slices/coreInfoSlice"
import TranLoadingWin from "components/LoadingWin/TranLoading"
import { useDisconnect } from "wagmi"
import MainBtnBrc20Com from "components/Brc20/MainBtnBrc20Com"
import { setBrc20 } from "hooks/redux/slices/appSlice"

const Brc20Page = () => {  
  const { isConnected } = useAppSelector((state) => state.wallet)
  const {fromChain, toChain, fromToken, toToken} = useAppSelector((state) => state.coreInfo)
  const { loading } = useAppSelector((state) => state.app)
  const { isBTC } = useBrc20Utils()
  const { disconnect } = useDisconnect()
  const dispatch = useAppDispatch()
  useBrc20DefData()

  const { disconnected: disconnectedByUnisat } = useUnisatWallet()
  const { disconnected: disconnectedByOkx } = useOkxBitcoinWallet()

  useEffect(() => {
    if(fromChain?.nickName) {
      disconnectedByOkx()
      disconnectedByUnisat()
    }
  }, [disconnectedByOkx, disconnectedByUnisat, fromChain?.nickName])

  useEffect(() => {
    disconnect()
    dispatch(setBrc20(true))
    return () => {
      disconnectedByOkx()
      disconnectedByUnisat()
      dispatch(setBrc20(false))
    }
  }, [disconnect, disconnectedByOkx, disconnectedByUnisat, dispatch])

  useEffect(() => {
    dispatch(setToToken(fromToken))
  }, [dispatch, fromToken])

  return <HomeWrap>
    <EmptyColumn></EmptyColumn>
    <InputWrap>
      <StyledContainer $height="30px"></StyledContainer>
      <SwitchBtnCom></SwitchBtnCom>
      <StyledContainer $height="60px"></StyledContainer>
      {/* from 资产 */}
      <AssetsSelectBrc20Com label="From" direction="from" chainDetail={fromChain} tokenDetail={fromToken}></AssetsSelectBrc20Com>
      <StyledContainer $height="4px"></StyledContainer>
      {/* to 资产 */}
      <AssetsSelectBrc20Com isBrc20={true} label="Into" direction="to" chainDetail={toChain} tokenDetail={toToken}></AssetsSelectBrc20Com>
      {/* 支付数量 */}
      {
        !isBTC && <>
          <StyledContainer $height="40px"></StyledContainer>
          <PayNumberCom></PayNumberCom>
        </>
      }
      {/* 功能列表 */}
      <StyledContainer $height="40px"></StyledContainer>
      <Brc20ReclipAddrCom></Brc20ReclipAddrCom>
    </InputWrap>
    <StyledContainer $width="24px"></StyledContainer>
    <OutWrap>
      {/* brc20 to EVM */}
      {
        isConnected && isBTC && <InscriptionListCom></InscriptionListCom>
      }
      {/* evm to brc20 */}
      {
        isConnected && !isBTC && <ReceiveBrc20Com></ReceiveBrc20Com>
      }
      {
        !isConnected && <>
          <EmptyWalletCom></EmptyWalletCom>
          <StyledContainer $height="60px"></StyledContainer>
          <MainBtnBrc20Com></MainBtnBrc20Com>
        </>
      }
      {/* loading 弹框 */}
      <LoadingWin loading={loading}></LoadingWin>
    </OutWrap>
    <TranLoadingWin></TranLoadingWin>
  </HomeWrap>
}

const EmptyColumn = styled(StyledContainer)`
  flex: 1;

  @media screen and (min-width: 1920px) {
    flex: 1;
  }
  @media screen and (min-width: 1440px) and (max-width: 1920px) {
    flex: 1;
  }
  @media screen and (min-width: 1024px) and (max-width: 1440px) {
    flex: 1;
  }
  @media screen and (min-width: 768px) and (max-width: 1024px) {
    flex: none;
    width: 24px;    
  }
  @media screen and (max-width: 768px) {
    flex: none;
    width: 24px;    
  }
`

const InputWrap = styled(StyledContainer)`
  flex: 4;
`

const OutWrap = styled(StyledContainer)`
  flex: 5;
  background-color: ${({theme}) => theme.basicWhite};
  background-image: url(${outBgImg});
  background-position: top;
  background-repeat: no-repeat;
  background-size: contain;
  box-sizing: border-box;
  padding: 125px 30px 0;

  position: relative;

`

const HomeWrap = styled(StyledContainer)`
  display: flex;
  min-height: 100vh;
  flex: 1;

  @media screen and (max-width: 768px) {
    flex-direction: column !important;
  }
`


export default Brc20Page